import PreQualTerms from 'partial/PreQualTerms/PreQualTermsController';

export default PreQualTerms;
